import { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Container } from './Container';
import { BrandLockup } from './BrandLockup';
import { CTAButton } from './CTAButton';

const nav = [
  { to: '/about', label: 'About' },
  { to: '/programs', label: 'Programs' },
  { to: '/quiz', label: 'Find Your Fit' },
  { to: '/contact', label: 'Contact' },
];

export function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--color-border)] bg-[var(--color-cream)]/85 backdrop-blur">
      <Container className="flex items-center justify-between py-4 sm:py-5">
        <Link to="/" aria-label="Your Lane Coaching, home" className="no-underline">
          <BrandLockup />
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-8 md:flex">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `text-[0.95rem] no-underline ${
                  isActive
                    ? 'text-[var(--color-ink)] font-semibold'
                    : 'text-[var(--color-ink-soft)] hover:text-[var(--color-ink)]'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <CTAButton to="/book-consult" size="md">
            Book a Free Consult
          </CTAButton>
        </nav>

        <button
          type="button"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((v) => !v)}
          className="rounded-md border border-[var(--color-border)] px-3 py-2 text-sm font-medium md:hidden"
        >
          {open ? 'Close' : 'Menu'}
        </button>
      </Container>

      {open && (
        <div id="mobile-nav" className="border-t border-[var(--color-border)] bg-[var(--color-cream)] md:hidden">
          <Container className="flex flex-col gap-4 py-5">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="text-base no-underline text-[var(--color-ink)]"
              >
                {item.label}
              </NavLink>
            ))}
            <CTAButton to="/book-consult" size="md" className="mt-1 w-fit">
              Book a Free Consult
            </CTAButton>
          </Container>
        </div>
      )}
    </header>
  );
}
